<template>
  <div class="component-modal" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{props.name ? `${$t("modal.commercial_config.products.edit")} ${props.name}` : $t("modal.commercial_config.products.create")}}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>
      
      <div class="component-modal__row component-modal__row__multiselect">
        <!-- <div class="component-modal-input component-modal-input--rename"> -->
          <label for="code">{{$t("modal.commercial_config.products.station")}}<small>*</small></label>
          <Multiselect
          v-model="model.stationId"
          :searchable="false"
          :canDeselect="false"
          :canClear="false"
          track-by="name"
          valueProp="id"
          label="name"
          :options="listStations" />

          <!--<select v-model="model.stationId">
            <option v-for="station in listStations" :key="station.id" :value='station.id'>{{station.name}}</option> 
          </select> -->
        <!-- </div> -->
      </div>


      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="name" id="name" autocomplete="off" :class="{'invalid': submitted && v$.model.name.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.commercial_config.products.name')" v-model="model.name" maxLength="255">
          <label for="name">{{$t("modal.commercial_config.products.name")}}
            <small v-if="submitted && v$.model.name.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="number" name="price" id="price" autocomplete="off" :class="{'invalid': submitted && v$.model.price.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.commercial_config.products.price')" v-model="model.price">
          <label for="price">{{$t("modal.commercial_config.products.price")}}
            <small v-if="submitted && v$.model.price.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>
    
      <div class="component-modal__row">
        <button type="button" @click.stop.prevent="saveAndClose">
          {{ props ? $t("modal.save") : $t('modal.create') }}
        </button>
        <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
          {{ $t("modal.cancel") }}
        </button>
      </div>

      <div class="component-modal__row" v-if="submitted && v$.model.$invalid">
        <div class="modal__form-error">
          <i class="material-icons">info_outline</i>
          <span v-html="$t('modal.common.required_message', {inputs : v$.model.$silentErrors.map(error => $t(`modal.commercial_config.products.${error.$property}`)).join(', ') })"></span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { required, maxLength } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    Multiselect
  },
  setup() {
		const v$ = useVuelidate();
    const store = useStore();
    const props = computed(() => store.getters.modal_getProps);
    const listStations = computed(() => store.getters.station_stations({name: ''}));
    const submitted = ref(false);
    const model = ref({
      stationId: '',
      name: '',
      price: ''
    })

    onMounted(() => {
      if (props.value.name) {
        model.value = Object.assign({}, props.value);
      } else {
        model.value.stationId = props.value.stationId
      }
    })

    async function closeModal() {
      await store.dispatch('modal_setActive');
      submitted.value = false;
    }

    async function saveAndClose() {
      submitted.value = true;
      if (!v$.value.model.$invalid) {
        try {
          await store.dispatch(props.value.name ? 'product_update' : 'product_create', model.value);
          this.closeModal();
        } catch (error) {
          console.error(error);
        }
      }
    }

    return {
      listStations,
      v$,
      props,
      model,
      submitted,
      saveAndClose,
      closeModal
    }
  },
	validations () {
    return {
      model: {
				name: {required, maxLengthValue: maxLength(255)},
        price: {required}
			}
    }
  }
};
</script>